import {
  GET_MARKET_SUMMARY_BEGIN,
  GET_MARKET_SUMMARY_SUCCESS,
  GET_MARKET_SUMMARY_FAIL,
  GET_MARKET_ASSET_BEGIN,
  GET_MARKET_ASSET_SUCCESS,
  GET_MARKET_ASSET_FAIL,
  SET_SELECTED_MARKET_ASSET,
  GET_MARKET_DATA_BEGIN,
  GET_MARKET_DATA_SUCCESS,
  GET_MARKET_DATA_FAIL,
  GET_ALL_MARKET_DATA_BEGIN,
  GET_ALL_MARKET_DATA_SUCCESS,
  GET_ALL_MARKET_DATA_FAIL,
  GET_MARKET_NEWS_BEGIN,
  GET_MARKET_NEWS_SUCCESS,
  GET_MARKET_NEWS_FAIL,
} from '../actions/types';

const initialState = {
  summary: {},
  asset: {},
  viewAsset: '',
  errors: [],
  marketData: {},
  allMarketData: {},
  marketLoading: false,
  assetLoading: false,
  marketDataLoading: false,
  marketNews: [],
  marketNewsLoading: false,
};

const market = (state = initialState, action) => {
  switch (action.type) {
    case GET_MARKET_SUMMARY_BEGIN:
      return {
        ...state,
        marketLoading: true,
      };
    case GET_MARKET_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.payload,
        marketLoading: false,
      };
    case GET_MARKET_SUMMARY_FAIL:
      return {
        ...state,
        marketLoading: false,
        errors: action.payload,
      };
    case GET_MARKET_ASSET_BEGIN:
      return {
        ...state,
        assetLoading: true,
      };
    case GET_MARKET_ASSET_SUCCESS:
      return {
        ...state,
        asset: action.payload,
        assetLoading: false,
      };
    case GET_MARKET_ASSET_FAIL:
      return {
        ...state,
        assetLoading: false,
        errors: action.payload,
      };
    case SET_SELECTED_MARKET_ASSET:
      return {
        ...state,
        viewAsset: action.payload,
      };
    case GET_MARKET_DATA_BEGIN:
      return {
        ...state,
        marketDataLoading: true,
      };
    case GET_MARKET_DATA_SUCCESS:
      return {
        ...state,
        marketData: action.payload,
        marketDataLoading: false,
      };
    case GET_MARKET_DATA_FAIL:
      return {
        ...state,
        marketDataLoading: false,
        errors: action.payload,
      };
    case GET_ALL_MARKET_DATA_BEGIN:
      return {
        ...state,
        marketDataLoading: true,
      };
    case GET_ALL_MARKET_DATA_SUCCESS:
      return {
        ...state,
        allMarketData: action.payload,
        marketDataLoading: false,
      };
    case GET_ALL_MARKET_DATA_FAIL:
      return {
        ...state,
        marketDataLoading: false,
        errors: action.payload,
      };
    case GET_MARKET_NEWS_BEGIN:
      return {
        ...state,
        marketNewsLoading: true,
      };
    case GET_MARKET_NEWS_SUCCESS:
      return {
        ...state,
        marketNews: action.payload,
        marketNewsLoading: false,
      };
    case GET_MARKET_NEWS_FAIL:
      return {
        ...state,
        marketNewsLoading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default market;
